import "./shimmer.css";

const CardLoader = ({ count = 4 }) => (
  <div className="shimmer-cards-row">
    {Array.from({ length: count }).map((_, index) => (
      <div key={index} className="shimmer-card">
        <div className="shimmer-block shimmer-card-title" />
        <div className="shimmer-block shimmer-card-value" />
      </div>
    ))}
  </div>
);

export default CardLoader;
